import api from './api'

const BASE = '/pm/requests'

export const pmRequestsService = {
  list: (params = {}) =>
    api.get(`${BASE}/`, { params: { page_size: 100, ...params } }).then((r) => r.data),
  create: (data) => api.post(`${BASE}/`, data).then((r) => r.data),
  counters: () => api.get(`${BASE}/counters/`).then((r) => r.data),
  take: (id) => api.post(`${BASE}/${id}/take/`).then((r) => r.data),
  // preventivi o fatture/avvisi collegabili a questa richiesta (stesso
  // cliente/commessa): per sceglierli per numero, non un id da conoscere a memoria
  candidates: (id) => api.get(`${BASE}/${id}/candidates/`).then((r) => r.data),
  fulfill: (id, data) => api.post(`${BASE}/${id}/fulfill/`, data).then((r) => r.data),
  reject: (id, reason) =>
    api.post(`${BASE}/${id}/reject/`, { reason }).then((r) => r.data),
}

export const REQUEST_KINDS = [
  { value: 'preventivo', label: 'Preventivo per un cliente' },
  { value: 'consegna', label: 'Consegna progetto e richiesta di pagamento' },
  { value: 'variante', label: 'Variante o integrazione' },
]

export const REQUEST_STATUSES = [
  { value: 'open', label: 'Aperta', color: 'yellow' },
  { value: 'taken', label: 'Presa in carico', color: 'blue' },
  { value: 'fulfilled', label: 'Evasa', color: 'green' },
  { value: 'rejected', label: 'Respinta', color: 'red' },
]
